import React from 'react'
import { Trans } from 'react-i18next'
import clsx from 'clsx'

import { Button, ButtonVariant } from '@makyoapp/makyo-ui'

import { useBilling } from '../Providers/BillingProviders'

const BillingAddonsPage = () => {
  const { billingCycle, quantities, handleQuantityChange, increaseQuantity, decreaseQuantity, addAddon } = useBilling()

  // Add-on data
  const addons = [
    { id: 'app', name: 'Extra Published App', price: 20 },
    { id: 'rows', name: 'Extra Rows (10,000)', price: 15 },
    { id: 'member', name: 'Extra Member', price: 10 },
    { id: 'team', name: 'Extra Team', price: 25 },
    { id: 'brandKit', name: 'Extra Brand Kit', price: 15 },
    { id: 'database', name: 'Extra Database', price: 20 },
    { id: 'storage', name: 'Extra Storage (1 GB)', price: 5 },
  ]

  return (
    <div className='bg-white dark:bg-transparent rounded-xl shadow-xs border border-gray-200 dark:border-gray-700 p-6 mb-8 -mt-4'>
      <h2 className='text-xl font-bold text-gray-900 dark:text-white mb-6'>
        <Trans>Add Additional Resources to Your Plan</Trans>
      </h2>
      <p className='text-sm text-gray-500 dark:text-gray-400 mb-6'>
        <Trans>Add resources to your current plan. Add-ons are billed based on your billing cycle.</Trans>
      </p>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        {addons.map((addon) => (
          <div key={addon.id} className='bg-gray-50 dark:bg-gray-900 rounded-lg p-4'>
            <div className='flex justify-between items-center'>
              <div>
                <h3 className='text-sm font-medium text-gray-700 dark:text-gray-300'>
                  <Trans>{addon.name}</Trans>
                </h3>
                <p className='text-xs text-gray-500 dark:text-gray-400'>
                  ${addon.price.toString()}/{billingCycle === 'yearly' ? 'mo' : 'mo'} per unit
                </p>
              </div>
              <div className='flex items-stretch'>
                <div className='flex border border-gray-300 dark:border-gray-600 rounded-md h-auto'>
                  <button
                    onClick={() => decreaseQuantity(addon.id)}
                    disabled={(quantities[addon.id] || 0) <= 0}
                    className={clsx(
                      'px-2 py-1 rounded-l-md',
                      'text-gray-500 dark:text-gray-400',
                      'hover:bg-gray-100 dark:hover:bg-gray-700',
                      'disabled:opacity-50'
                    )}
                  >
                    <svg className='h-4 w-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M20 12H4' />
                    </svg>
                  </button>
                  <input
                    type='number'
                    value={quantities[addon.id] || 0}
                    onChange={(e) => handleQuantityChange(addon.id, e.target.value)}
                    className={clsx(
                      'w-12 text-center py-1 text-xs',
                      'border-x border-gray-300 dark:border-gray-600',
                      'text-gray-700 dark:text-gray-200',
                      'bg-white dark:bg-gray-800',
                      '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none'
                    )}
                    min='0'
                    max='99'
                    style={{ appearance: 'textfield' }}
                  />
                  <button
                    onClick={() => increaseQuantity(addon.id)}
                    className={clsx(
                      'px-2 py-1 rounded-r-md',
                      'text-gray-500 dark:text-gray-400',
                      'hover:bg-gray-100 dark:hover:bg-gray-700'
                    )}
                  >
                    <svg className='h-4 w-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 4v16m8-8H4' />
                    </svg>
                  </button>
                </div>
                <Button
                  variant={ButtonVariant.Normal}
                  disabled={(quantities[addon.id] || 0) <= 0}
                  onClick={() => addAddon({ ...addon, quantity: quantities[addon.id] || 0 })}
                  className='ml-3'
                >
                  <Trans>Add</Trans>
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BillingAddonsPage
